import React, { useState, useEffect } from "react";
import { Row, Container } from "reactstrap";
import { connect } from "react-redux";
import { ModalCollections } from "../../../../modals/modalCollections";
import {
  addCategory2,
  getAvailableCategories2,
  getSelectedCategories2,
  addCategories2,
  getSelectedComponentsCurrentConfiguration,
  changeCategoryOrder,
  removeCategory2,
  getComponentCollectionImages
} from "../../../../../ducks";
import { addMarginTop } from "../../../../utils/utilities";
import { CustomButton } from "../../home-layout-draggable-columns/custom-button";
import { useTranslation } from "react-i18next";

export const UpdateContentSectionBaseCategories = ({
  title,
  availableCategories,
  currentProduct,
  label,
  onInit,
  currentSelectedConfiguration,
  onChange,
  parentOption,
  storeKey
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState(0);

  const done = (params) => {

    setSelectedItems(params.configuration.products.length);
    onChange(params.label, params.configuration.products, parentOption);
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedItems(currentProduct ? currentProduct.length : 0);   
  }, [currentProduct]);

  return (
    <Container style={addMarginTop(title)}>
      <Row>
        <CustomButton
          type="CONTENT"
          onClick={() => setIsOpen(true)}
          label={t("homeModalCollections.title").toUpperCase()}          
          counter={true}
          itemsCounter={selectedItems}
        />
      </Row>
      <ModalCollections
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onDone={done}
        label={label}
        availableCategories={availableCategories}
        selectedCategories={currentProduct}
        onInit={onInit}
        currentSelectedConfiguration={currentSelectedConfiguration}
        parentOption={parentOption}
        selectOneItem={true}
        storeKey={storeKey}
      />
    </Container>
  );
};

const mapStateToProps = (state, ownProps) => ({
  availableCategories: getAvailableCategories2(state),
  selectedCategories: getSelectedCategories2(state),
  currentSelectedConfiguration: getSelectedComponentsCurrentConfiguration(
    state
  ),
  currentProduct: getComponentCollectionImages(state, { imageNumber: ownProps.parentOption.split(' ')[1] }) // Split the parentOption string on space and take the second part (the number)
});

const dispatchToProps = {
  dropCategory: addCategory2,
  onInit: addCategories2,
  onReArrangeIndex: changeCategoryOrder,
  onRemoveCategory: removeCategory2,
};

export const UpdateContentSectionCategories2 = connect(
  mapStateToProps,
  dispatchToProps
)(UpdateContentSectionBaseCategories);
